import React, { useContext, useState } from "react";
import SocialMediaWrapper from "../rj-components/SocialMediaWrapper";
import SiteButton from "../rj-components/SiteButton";
import moment from "moment";
import { Link } from "react-router-dom";
import CompanyLogo from "../../layouts/CompanyLogo";
import GlobalContext from "../../contexts/store";
import { toast } from "react-toastify";
import { Post } from "../../api/server";
import formatPhoneNumber from "../../helpers/formatPhoneNumber";
import DinnerAndShowPromoCard from "../DinnerAndShowPromoCard";

function RJFooter() {
  const { company } = useContext(GlobalContext);
  const [focused, setFocused] = useState(false);

  const [values, setValues] = useState({
    email: "",
  });

  const resetForm = () => {
    setValues({
      email: "",
    });
  };

  const handleFocused = (e) => {
    setFocused(true);
  };

  const notify = (data, type) => {
    toast(data, {
      type: type || "default",
      theme: "dark",
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    Post("/users", {
      email: values.email,
      company: company._id,
    })
      .then(() => {
        resetForm();
        notify("Thank you for subscribing!", "success");
      })
      .fail((err) => {
        resetForm();
        notify(err.responseJSON, "error");
      });
  };

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  return (
    <footer className="flex justify-center items-center pb-16 bg-black">
      <div className="flex flex-col w-full mt-4">
        <div className="flex flex-col items-center gap-6 w-[95%] mx-auto border-b-[0.5px] pb-[30px] border-white/10 px-[5%] md:flex-row md:justify-between md:items-center md:gap-0 md:px-[10%]">
          <div className="flex flex-col items-center">
            <CompanyLogo size={120} isDark={false} />
            {/* <SocialMediaWrapper /> */}
            <Link to="/terms">
              <p className="mt-3 opacity-60 text-white text-xs">Terms and Conditions</p>
            </Link>
          </div>

          {/* <div className="flex flex-col items-center md:items-start">
            <h5 className="font-bold text-white">TABLES</h5>
            <p className="opacity-60 text-white mb-[-3px]">
              For Reservations Please Contact
            </p>
            <a
              href="mailto:Hello@firstandbell.com"
              className="opacity-60 text-white mb-[-3px] no-underline"
            >
              Hello@firstandbell.com
            </a>
            <br />
            <Link className="no-underline" to={"/terms"}>
              <p className="opacity-60 text-white">Terms and Conditions</p>
            </Link>
          </div> */}

          <DinnerAndShowPromoCard />

          <div className="flex flex-col items-center md:items-start">
            <h5 className="text-[16px] font-bold text-white mt-[20px]">
              CONTACT
            </h5>
            <a
              href={`mailto:${company?.email}`}
              className="text-[12px] opacity-60 text-white mb-[-3px] no-underline"
            >
              {company?.email}
            </a>
            <a
              href={`tel:${company?.phone}`}
              className="text-[12px] opacity-60 text-white mb-[-3px] no-underline"
            >
              {formatPhoneNumber(company?.phone)}
            </a>
            <br />
            <p className="text-[12px] opacity-60 text-white mb-[-3px]">
              {company?.address}
            </p>
            <p className="text-[12px] opacity-60 text-white mb-[-3px]">
              {company?.city}, {company?.state} {company?.zip}
            </p>
          </div>

          {/* <div className="flex flex-col items-center md:items-start flex-grow max-w-full md:max-w-[20%]">
            <h5 className="font-bold text-white">SUBSCRIBE</h5>
            <p className="opacity-60 text-white">Email Address</p>
            <input
              className="bg-black border-b border-gray-400 outline-none text-white mb-2 py-2 w-full placeholder:text-gray-500"
              value={values.email}
              name="email"
              placeholder="Enter your email"
              onChange={onChange}
              onBlur={handleFocused}
            />
            <SiteButton buttonText={"Subscribe"} onClick={handleSubmit} />
          </div> */}
        </div>
        <div className="flex justify-center items-center">
          <span className="text-white mt-4">
            On The Strip Ticketing © {moment().year()}
          </span>
        </div>
      </div>
    </footer>
  );
}

export default RJFooter;
